export default {
    none:0,
    serviceStartStep: 1,
    servicesStep: 2,
    carStep: 3,
    workshopStep: 4,
    userFormStep: 5,
    confirmStep: 6,
    thanksStep: 7
};